[
  { "label": "Unpaid", "id": "Unpaid" },
  { "label": "Training", "id": "Training" },
  { "label": "Entry", "id": "Entry" },
  { "label": "Senior", "id": "Senior" },
  { "label": "Manager", "id": "Manager" },
  { "label": "Director", "id": "Director" },
  { "label": "VP", "id": "VP" },
  { "label": "CXO", "id": "CXO" },
  { "label": "Partner", "id": "Partner" },
  { "label": "Owner", "id": "Owner" }
]
